import type { DocumentDrawingTarget } from 'features/libra/document/LibraDocumentContext'
import { SmartImageViewer } from 'features/libra/drawing/SmartImageViewer'
import React, { ComponentProps, FC } from 'react'
import { createPortal } from 'react-dom'

type Props = Omit<
  ComponentProps<typeof SmartImageViewer>,
  'url' | 'documentId' | 'height'
> & {
  target?: DocumentDrawingTarget
}

export const DocumentDrawingView: FC<Props> = ({ target, ...viewerProps }) =>
  target?.url
    ? createPortal(
        <SmartImageViewer
          {...viewerProps}
          url={target.url}
          documentId={target.documentId}
          height='100%'
        />,
        target.element
      )
    : null
